import { useEffect, useMemo } from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { EditFileUploaded } from '@/component/common/EditFileUploaded';
import { I18n } from 'aws-amplify';
import EmailAttachmentViewOnly from './EmailAttachmentViewOnly';

export default function ContentEmailAttachment({
    detailTicket,
    currentEmailTicket,
    fieldData,
    setIsShowPopupLogout,
    isUnDeliverTicket,

    fileUploadList,
    setFileUploadList,
    fileUpdatedList,
    setFileUpdatedList,
    fileDeletedList,
    setFileDeletedList,
    currentAttachmentError,
    setCurrentAttachmentError,

    setIsEditedCurrentTicket,
    isDisableEdit,
    isTriggerReloadCurrentTicket,
}) {
    let props = {
        setListFieldEdited: () => {},
        name:fieldData.id,
        data:fieldData,
        selectTicketType: 'Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL',
        ticketType: Constant.TICKET_TYPE.EMAIL_REPLY,
        detailTicket: detailTicket,
        setErrorCreateTicket: () => {},
        setError: () => {},
        errorlist: [],
        fileUploading: [],
        componentName: null,
        addTicket: true,
        setValue: () => {},
        register: () => {},
        clearErrors: () => {},
        setIsEdited: setIsEditedCurrentTicket,
        isDisableEdit: isDisableEdit
    }

    // handle error attachment
    useEffect(() => {
        if (!isUnDeliverTicket) return;
        
        let totalFileSize = 0;
        if (!Utils.isEmptyArray(fileUploadList)) {
            fileUploadList.forEach(file => {
                if (file?.file?.size) {
                    totalFileSize += parseInt(file?.file?.size);
                }
            })
        }
        if (!Utils.isEmptyArray(fileUpdatedList)) {
            const currentFileList = [...fileUpdatedList].filter(f => !fileDeletedList.find(deleted => deleted.fileUrl === f.fileUrl));
            currentFileList.forEach(file => {
                if (file?.fileSize) {
                    totalFileSize += parseInt(file?.fileSize);
                }
            })
        }
        
        let convertTotalFileSizeToMB = Utils.convertByteToMB(totalFileSize);
        setCurrentAttachmentError(prev => {
            if (convertTotalFileSizeToMB > Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) {
                return I18n.get('MGS-FILE-OVER-CAPACITY').replace('{{fileSize}}', Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET)
            }
            return ''
        });
        
    }, [fileUploadList, fileUpdatedList, fileDeletedList])

    // Prepare detailTicket by attachFiles form currentEmailTicket
    const overrideDetailTicket = useMemo(() => {
        if (Utils.isEmptyArray(fieldData.value)) {
            return detailTicket;
        }

        let listAttachmentOfCurrentTicket = fieldData.value;
        
        const transformedAttachFiles = listAttachmentOfCurrentTicket.map(attachment => {
            const matchedAttachFile = detailTicket?.attachFiles?.find(attachFile => {
                const s3Path = attachFile?.s3Path || attachFile?.fileInfo?.fileUrl;
                const fileUrl = attachment?.fileUrl || attachment?.file?.url;
                return s3Path === fileUrl;
            });
            if (!matchedAttachFile) return null;
            return matchedAttachFile;
        });
        
        return {
            ...detailTicket,
            ...currentEmailTicket,
            attachFiles: transformedAttachFiles.filter(file => file !== null)
        };
    }, [currentEmailTicket, fieldData?.value, detailTicket, isTriggerReloadCurrentTicket]);

    const shouldUseEditMode = isUnDeliverTicket && !isDisableEdit;

    // Don't render in view mode when there's no data
    if (!shouldUseEditMode && Utils.isEmptyArray(fieldData?.value)) {
        return null;
    }

    // Show title only in edit mode or when has files
    const shouldShowTitle = shouldUseEditMode || !Utils.isEmptyArray(fieldData?.value);

    return (
        <div className='form-addTicket'>
            {shouldShowTitle && (
                <div className="cell-prod-status gap-8 attach-file-chat-post-title">
                    <label className='form-addTicket-label'>添付ファイル</label>
                </div>
            )}
            <div className='form-addTicket-input'>
                {shouldUseEditMode ? (
                    <EditFileUploaded
                        defaultValue={fieldData.value}
                        fileUploadList={fileUploadList}
                        setFileUploadList={setFileUploadList}
                        fileUpdatedList={fileUpdatedList}
                        setFileUpdatedList={setFileUpdatedList}
                        fileDeletedList={fileDeletedList}
                        setFileDeletedList={setFileDeletedList}
                        setIsShowPopupLogout={setIsShowPopupLogout}
                        attachmentError={currentAttachmentError}
                        isTriggerReloadCurrentTicket={isTriggerReloadCurrentTicket}
                        isEmail={true}
                        {...props}
                        detailTicket={overrideDetailTicket} // override detailTicket
                    />
                ) : (
                    <EmailAttachmentViewOnly
                        fieldData={fieldData}
                        detailTicket={overrideDetailTicket}
                        setIsShowPopupLogout={setIsShowPopupLogout}
                    />
                )}
            </div>
        </div>
    );
}
